(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* Enable hover-based dropdowns on desktop */
  function pfriemEnableHoverDropdown() {
    if (window.innerWidth < 990) return;
    var wrapper = document.querySelector('.pfriem-header-wrapper');
    var dimmer = document.querySelector('.main-nav-dimmer');
    if (!wrapper) return;

    document
      .querySelectorAll('.pfriem-header .header__inline-menu li')
      .forEach(function (item) {
        // Only apply hover behavior to items that actually have a dropdown submenu
        var hasSubmenu =
          item.querySelector('header-menu details .header__submenu') !== null;
        if (!hasSubmenu) return;

        if (item.dataset.pfriemHoverBound === 'true') return;
        item.dataset.pfriemHoverBound = 'true';

        item.addEventListener('mouseenter', function () {
          /* Re-open details if theme closed it (e.g. after focus left to DevTools) */
          var details = item.querySelector('header-menu details');
          if (details) details.setAttribute('open', 'open');
          wrapper.classList.add('pfriem-submenu-active');
          if (dimmer) dimmer.classList.add('is-active');
        });

        item.addEventListener('mouseleave', function () {
          wrapper.classList.remove('pfriem-submenu-active');
          if (dimmer) dimmer.classList.remove('is-active');
        });
      });
  }

  pfriemEnableHoverDropdown();
  window.addEventListener('resize', pfriemEnableHoverDropdown);

  /* On desktop, prevent summary click from toggling details (hover-only) */
  document.addEventListener('click', function (e) {
    if (window.innerWidth < 990) return;
    var summary = e.target.closest('.pfriem-header summary');
    if (!summary) return;
    var details = summary.closest('details');
    if (!details || !details.querySelector('.header__submenu')) return;
    e.preventDefault();
  }, true);

  } catch(e) { console.error(e); }
})();
})();
